export default __webpack_public_path__ + "static/media/ficon-3.0ac6b7e6.svg";